"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.symbol = void 0;

var helpers = _interopRequireWildcard(require("./helpers"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var symbol = Symbol();
exports.symbol = symbol;

var _default = function _default(spec) {
  var types = helpers.createTypes(spec.name);
  return {
    selectors: helpers.createSelectors(spec.selector),
    reducer: helpers.createApiReducer(types),
    request: helpers.createAction(spec, types),
    types: types
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/createApi.js
// module id = 274
// module chunks = 0